import { motion } from 'motion/react';
import { raffleFlyOffDelta } from './disposal';

const GHOSTS = [0.28, 0.5, 0.72];

/** Staggered copies so fly-off reads as a motion trail. */
export function FlyOffTrail({ submissionId }: { submissionId: string }) {
  const delta = raffleFlyOffDelta(submissionId);
  return (
    <motion.div
      className="pointer-events-none absolute inset-0 z-0 overflow-visible"
      variants={{
        rest: { opacity: 0 },
        dispose: { opacity: 1, transition: { duration: 0.08 } },
      }}
    >
      {GHOSTS.map((t, index) => (
        <motion.div
          key={index}
          className="absolute inset-0 rounded-md"
          style={{
            background:
              'linear-gradient(90deg, rgba(245,185,66,0.55), rgba(255,107,61,0.35))',
            filter: 'blur(3px)',
          }}
          variants={{
            rest: { x: 0, y: 0, opacity: 0, rotate: 0 },
            dispose: {
              x: delta.x * t,
              y: delta.y * t,
              rotate: delta.rotate * t,
              opacity: [0.55, 0],
              transition: {
                duration: 0.7,
                delay: index * 0.04,
                ease: [0.15, 0.7, 0.25, 1],
              },
            },
          }}
        />
      ))}
    </motion.div>
  );
}
